import { defineMessages } from 'react-intl';

var messages = defineMessages({
  ariaLabel: {
    id: "neptune.Info.ariaLabel"
  }
});

export { messages as default };
//# sourceMappingURL=Info.messages.mjs.map
